<div class="date-time-wrapper">
    <mat-form-field class="date-field" [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'" appearance="fill">
        <mat-label>Datum</mat-label>
        <input
            [matDatepicker]="picker"
            [value]="date"
            [disabled]="fc.disabled"
            (dateChange)="date = $event.value"
            matInput
            type="text" />
        <mat-datepicker-toggle [for]="picker" [disabled]="fc.disabled" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="time-field" [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'" appearance="fill">
        <mat-label>Tijd</mat-label>
        <input [value]="time" [disabled]="fc.disabled" (input)="time = $event.target.value" matInput type="time" />
    </mat-form-field>
</div>
